import "rsuite/dist/rsuite.css";
import React, { useState, useEffect, useCallback } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Form, Container, Row, Col, Table, Button } from 'react-bootstrap';
import { renderPagination, renderAdvancedPagination, Create_Bill_Modal } from '../utilities';
import { DateRangePicker } from 'rsuite';
import '../Functions/manage_orders.css';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash/debounce';

// MODULE-LEVEL VARIABLE
// This persists across navigation (unmount/remount) but resets on Page Reload.
let cachedSelectedChallans = [];

function CreateBill() {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [orders, setOrders] = useState([]);
    const [job_number, set_job_number] = useState('');
    const [challan_no, set_challan_no] = useState('');
    const [searchClick, setSearchClick] = useState(false); 
    const [style, set_style] = useState('');
    const [filters, setFilters] = useState({
        teamname: '',
        partyname: '',
        buyername: '',
        itemname: '',
        specification: '',
    });
    const [dateRange, setDateRange] = useState([]);

    const [team_options, set_team_options]=useState([]);
    const [party_options, set_party_options]=useState([]);
    const [buyer_options, set_buyer_options]=useState([]);
    const [item_options, set_item_options]=useState([]);
    const [spec_options, set_spec_options]=useState(['Ply 1','Ply 2','Ply 3','Ply 5','Ply 7','PP']);

    // Initialize state from the module-level cache
    const [selectedChallans, setSelectedChallans] = useState(cachedSelectedChallans);
    
    const [showCreateBillModal, setShowCreateBillModal] = useState(false);

    useEffect(() => {
        fetch_dropdown_options();
    }, []);

    // Sync state changes back to the module-level cache
    useEffect(() => {
        cachedSelectedChallans = selectedChallans;
    }, [selectedChallans]);

    const fetch_dropdown_options = async () => {
        try {
            const response1 = await axios.get(`${window.backendUrl}/get_all_teams`);
            const response2 = await axios.get(`${window.backendUrl}/get_all_parties`);
            const response3 = await axios.get(`${window.backendUrl}/get_all_buyers`);
            const response4 = await axios.get(`${window.backendUrl}/get_all_items`);

            const options1 = response1.data.data.map((team) => team['Name']);
            const options2 = response2.data.data.map((party) => party['PartyName']);
            const options3 = response3.data.data.map((buyer) => buyer['Name']);
            const options4 = response4.data.data.map((item) => item['Name']);
            
            set_team_options(options1);
            set_party_options(options2);
            set_buyer_options(options3);
            set_item_options(options4);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFormData) => ({ ...prevFormData, [name]: value }));
        
        // CLEAR SELECTION ON FILTER CHANGE
        setSelectedChallans([]); 
        
        setCurrentPage(1);
    };

    const handleSearch = () => {
        setSearchClick(true);
        setCurrentPage(1);
    };

    const handleDateRangeChange = (value) => {
        if (value && value.length === 2) {
            setDateRange(value);
        } else {
            setDateRange([]);
        }
        // CLEAR SELECTION ON DATE CHANGE
        setSelectedChallans([]);
    };

    const fetchDataWithFilters = (page, filters, dateRange, job_number, style, challan_no) => { 
        const { teamname, partyname, buyername, itemname, specification} = filters; 
        const start_date = dateRange[0] ? dateRange[0] : ''
        const end_date = dateRange[1] ? dateRange[1] : ''

        axios.get(`${window.backendUrl}/get_all_delivery_challans_for_new_bill`, {
            params: { teamname, partyname, buyername, itemname, specification, page, job_number, style, challan_no, start_date, end_date}
        })
        .then((response) => {
            setOrders(response.data.data);
            setCurrentPage(response.data.currentPage);
            setTotalPages(response.data.totalPages);
            setSearchClick(false);
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const debouncedFetchData = useCallback(
        debounce((page, filters, dateRange, job_number, style, challan_no) => {
            fetchDataWithFilters(page, filters, dateRange, job_number, style, challan_no);
        }, 300), 
        []
    );

    useEffect(() => {
        debouncedFetchData(currentPage, filters, dateRange, job_number, style, challan_no);
        return () => {
            debouncedFetchData.cancel();
        };
    }, [filters, currentPage, searchClick, dateRange, job_number, style, challan_no, debouncedFetchData]);

    
    // Checkbox Handler
    const handleCheckboxChange = (e, challanId, partyName) => {
        if (e.target.checked) {
            setSelectedChallans(prev => [...prev, { id: challanId, party: partyName }]);
        } else {
            setSelectedChallans(prev => prev.filter(item => item.id !== challanId));
        }
    };

    // Open Modal Handler
    const handleNewBillClick = () => {
        if (selectedChallans.length === 0) {
            alert("Please select at least one challan.");
            return;
        }

        const firstParty = selectedChallans[0].party;
        const allSameParty = selectedChallans.every(item => item.party === firstParty);

        if (!allSameParty) {
            alert("All selected challans must belong to the same Party.");
            return;
        }

        setShowCreateBillModal(true);
    };

    // Save Bill Handler
    const handleSaveBill = async (billNo) => {
        const challanIds = selectedChallans.map(item => item.id);
        
        try {
            await axios.post(`${window.backendUrl}/create_bill`, {
                bill_no: billNo,
                challan_ids: challanIds
            });
            alert("Bill Created Successfully!");
            
            // Clear selections after successful creation
            setSelectedChallans([]); 

            // Refresh Data
            fetchDataWithFilters(currentPage, filters, dateRange, job_number, style, challan_no);
        } catch (error) {
            console.error("Error creating bill", error);
            alert("Failed to create bill. Please try again.");
        }
    };

    return (
    <>
        <NavigationBar />
        <Container fluid>
            <Row style={{ marginTop: '20px',marginBottom:'10px' }}>
                <Col>
                <h4>Create Bill</h4>
                </Col>
                <Col>
                    <Button 
                        variant="primary"
                        style={{marginRight:'10px', fontWeight:'bold'}} 
                        onClick={handleNewBillClick}
                    >
                        <span style={{fontWeight:'bold', marginRight:'5px'}}>+</span> New Bill
                    </Button>
                    <DateRangePicker placeholder="Select Challan Date Range" onChange={handleDateRangeChange}/>
                </Col>
                <Col>
                    {renderPagination({ totalPages, currentPage, setCurrentPage })}
                    {renderAdvancedPagination({ totalPages, currentPage, setCurrentPage })}
                </Col>
            </Row>
            
            <Row style={{ marginTop: '20px',marginBottom:'10px' }}>
                <Form className='d-flex flex-wrap justify-content-around' onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
                    <Form.Select style={{width:'150px'}} name="partyname" value={filters.partyname} onChange={handleInputChange}>
                        <option value="">All Parties</option>
                        {party_options.map((party, index) => (
                            <option key={index} value={party}>{party}</option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="buyername" value={filters.buyername} onChange={handleInputChange}>
                        <option value="">All Buyers</option>
                        {buyer_options.map((buyer, index) => (
                            <option key={index} value={buyer}>{buyer}</option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="itemname" value={filters.itemname} onChange={handleInputChange}>
                        <option value="">All Items</option>
                        {item_options.map((item, index) => (
                            <option key={index} value={item}>{item}</option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="specification" value={filters.specification} onChange={handleInputChange}>
                        <option value="">All specification</option>
                        {spec_options.map((team, index) => (
                            <option key={index} value={team}>{team}</option>
                        ))}
                    </Form.Select>
                    
                    <Form.Control style={{width:'150px'}} type="text" name="style" value={style} onChange={(e) => { set_style(e.target.value); setCurrentPage(1); }} placeholder='Style/ LPD PO No.' />

                    <Form.Control style={{width:'150px'}} type="text" name="challan_no" value={challan_no} onChange={(e) => { set_challan_no(e.target.value); setCurrentPage(1); }} placeholder='Challan No.' />

                    <div className="search_container" style={{width:'150px'}} >
                        <Form.Control type="text" name="job_number" value={job_number} onChange={(e) => { set_job_number(e.target.value); setCurrentPage(1); }} placeholder='Job No.' />
                        <div onClick={handleSearch}><i className="fa fa-search"></i></div>
                    </div>
                </Form>
            </Row>

            <Row>
                <Col>
                    <Table bordered striped condensed="true" style={{ fontSize: '13px', overflowY: 'auto'  }}>
                        <thead className="cf" style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                            <tr>
                                <th rowSpan="2" style={{width: '40px'}}>Select</th>
                                <th >ID</th>
                                <th rowSpan="2">Challan#</th>
                                <th>Job#</th>
                                <th>Company</th>
                                <th rowSpan="2">Items</th>
                                <th rowSpan="2">Specif.</th>
                                <th>Measurement</th>
                                <th rowSpan="2">Ord.<br/>Qty</th>
                                <th rowSpan="2">Prod.<br/>Done</th>
                                <th colSpan="2">Delivery Info</th>
                                <th colSpan="2">Delivery Balance</th>
                                <th rowSpan="2">Packet</th>
                                <th rowSpan="2">Remarks</th>
                                <th>Vehicle</th>
                                <th rowSpan="2">Deli. Station</th>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <th>Style#</th>
                                <th>Buyer</th>
                                <th>LxWxH</th>
                                <th>Qty</th>
                                <th>Value</th>
                                <th>Qty</th>
                                <th>Value</th>
                                <th>Driver</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((order, orderIndex) => {
                                const orderRows = order.items.map((item, itemIndex) => (
                                    item.specifications.map((spec, specIndex) => (
                                        spec.gsms.map((gsm, gsmIndex) => {
                                            const rowSpanLength = order.items.reduce((acc, item) => acc + item.specifications.reduce((acc, spec) => acc + spec.gsms.length, 0), 0);

                                            return (
                                                <tr key={`${orderIndex}-${itemIndex}-${specIndex}-${gsmIndex}`}>
                                                    {gsmIndex === 0 && specIndex === 0 && itemIndex === 0 && (
                                                        <>
                                                            <td rowSpan={rowSpanLength} style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                                <input 
                                                                    type="checkbox" 
                                                                    onChange={(e) => handleCheckboxChange(e, order.challanId, order.partyName)}
                                                                    checked={selectedChallans.some(item => item.id === order.challanId)}
                                                                />
                                                            </td>
                                                            <td rowSpan={rowSpanLength}>{order.serial_no}
                                                                <hr style={{ border: '1px solid black' }}/>
                                                                {new Date(order.deliveryDate * 1000).toLocaleString('en-GB', { timeZone: 'Asia/Dhaka', day: '2-digit', month: '2-digit', year: 'numeric'}).replace(/\//g, '.')}
                                                            </td>
                                                            <td rowSpan={rowSpanLength}>{order.challan_no}</td>
                                                            <td style={{width: '300px', wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word'}} rowSpan={rowSpanLength}>{order.jobNo}<hr style={{ border: '1px solid black' }}/>{order.style}</td>
                                                            <td rowSpan={rowSpanLength}>{order.partyName}<hr style={{ border: '1px solid black' }}/>{order.buyerName}</td>
                                                        </>
                                                    )}
                                                    
                                                    {gsmIndex === 0 && specIndex === 0 && (
                                                        <td style={{ verticalAlign: 'middle' }} rowSpan={item.specifications.reduce((acc, spec) => acc + spec.gsms.length, 0)}>{item.itemName}</td>
                                                    )}
                                                    
                                                    {gsmIndex === 0 && (
                                                        <td style={{ verticalAlign: 'middle' }} rowSpan={spec.gsms.length}>{spec.specification}</td>
                                                    )}
                                                    
                                                    <td>{gsm.measurement}</td>
                                                    <td>{gsm.orderQuantity}</td>
                                                    <td>{gsm.finishedQty}</td>
                                                    <td>{gsm.deliveryQty}</td>
                                                    <td>{gsm.currency === '$' ? '$' : '৳'}{(gsm.deliveryQty * parseFloat(gsm.unitPrice)).toFixed(2)}</td>
                                                    <td>{gsm.deliveryBalance}</td>
                                                    <td>{gsm.currency === '$' ? '$' : '৳'}{(gsm.deliveryBalance * parseFloat(gsm.unitPrice)).toFixed(2)}</td>
                                                    <td>{gsm.packet_qty_sum}</td>
                                                    
                                                    {gsmIndex === 0 && specIndex === 0 && itemIndex === 0 && (
                                                        <>
                                                            <td style={{ verticalAlign: 'middle' }} rowSpan={rowSpanLength}>{order.remarks}</td>
                                                            <td style={{ verticalAlign: 'middle' }} rowSpan={rowSpanLength}>{order.vehicleNo}<hr style={{ border: '1px solid black' }}/>{order.driverName}</td>
                                                            <td style={{ verticalAlign: 'middle' }} rowSpan={rowSpanLength}>{order.deliveryStation}</td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })
                                    ))
                                ));

                                return orderRows;
                            })}
                        </tbody>
                    </Table>

                    <Create_Bill_Modal 
                        show={showCreateBillModal} 
                        setShow={setShowCreateBillModal} 
                        handleSave={handleSaveBill}
                    />
                </Col>
            </Row>
        </Container>
    </>
    )
}

export default CreateBill